import React from 'react';
import PropTypes from 'prop-types';
import { Text } from './style';

const Amount = ({
  original: { invoices = [] },
}) => {
  const { amount = 0 } = invoices[invoices.length - 1] || {};
  return (
    <Text>
      {Number(amount).toFixed(2)}
      €
    </Text>
  );
};

Amount.propTypes = {
  original: PropTypes.shape({
    invoices: PropTypes.array,
  }),
};

Amount.defaultProps = {
  original: {},
};

export default Amount;
